module.exports = __webpack_public_path__ + "img/home-line4-img5.8f301b16.png";